'use client'
import { useState } from 'react'
import Image from 'next/image'

import CMButton from './buttons/cmButton'
import ImageLink from './imageLink/imageLink'
import SideBar from './side-bar/side-bar'
import SvgIcon from './svg-icons/svg-icons'
import NavLinks from './nav-links'
import { ViewPort } from '@/enum/enum'
import { HeaderLayout, GeneralLayout } from '@/payload-types'
import SocialMediaLink from './social-link/social-link'
import { SocialLinkItem } from './social-link/social-link'

interface IProps {
  header?: HeaderLayout
  general?: GeneralLayout
}

export type MenuItem = {
  name?: string | null
  url?: string | null
  subMenu?:
    | {
        name?: string | null
        url?: string | null
        id?: string | null
      }[]
    | null
  id?: string | null
}

export const reportIndividualSvg = (
  <SvgIcon width="20" height="20" viewBox="0 0 20 20" fill="none">
    <g clipPath="url(#clip0_6667_3232)">
      <path
        d="M10 0C8.02219 0 6.08879 0.58649 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17316C0.00433284 8.00042 -0.1937 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8078C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C19.9971 7.34873 18.9426 4.80688 17.0679 2.93215C15.1931 1.05741 12.6513 0.0029116 10 0ZM10 5C10.5933 5 11.1734 5.17595 11.6667 5.50559C12.1601 5.83523 12.5446 6.30377 12.7716 6.85195C12.9987 7.40013 13.0581 8.00333 12.9424 8.58527C12.8266 9.16721 12.5409 9.70176 12.1213 10.1213C11.7018 10.5409 11.1672 10.8266 10.5853 10.9424C10.0033 11.0581 9.40013 10.9987 8.85195 10.7716C8.30377 10.5446 7.83524 10.1601 7.50559 9.66671C7.17595 9.17336 7 8.59334 7 8C7 7.20435 7.31607 6.44129 7.87868 5.87868C8.44129 5.31607 9.20435 5 10 5ZM10 18C8.23921 18.0019 6.51698 17.4843 5.049 16.512C5.16502 15.5451 5.63092 14.6541 6.35879 14.0071C7.08666 13.3601 8.02615 13.0019 9 13H11C11.9739 13.0019 12.9134 13.3601 13.6412 14.0071C14.3691 14.6541 14.835 15.5451 14.951 16.512C13.483 17.4843 11.7608 18.0019 10 18Z"
        fill="#FF1D1D"
      />
    </g>
    <defs>
      <clipPath id="clip0_6667_3232">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </SvgIcon>
)

export const reportIncidentSvg = (
  <SvgIcon width="20" height="20" viewBox="0 0 20 20" fill="none">
    <g clipPath="url(#clip0_6666_3221)">
      <path
        d="M15.133 11.0862V9.19145C15.1337 7.91088 14.724 6.6675 13.9702 5.66238C13.2163 4.65725 12.1625 3.94916 10.979 3.65258C10.988 3.61584 10.995 3.57859 11 3.541V1.05262C11 0.773446 10.8946 0.505709 10.7071 0.308305C10.5196 0.110901 10.2652 0 10 0C9.73478 0 9.48043 0.110901 9.29289 0.308305C9.10536 0.505709 9 0.773446 9 1.05262V3.541C9.00497 3.57859 9.01199 3.61584 9.021 3.65258C7.83751 3.94916 6.78365 4.65725 6.02984 5.66238C5.27603 6.6675 4.86633 7.91088 4.867 9.19145V11.0862C4.867 13.5977 3 14.2251 3 15.4808C3 16.105 3 16.7366 3.538 16.7366H16.462C17 16.7366 17 16.105 17 15.4808C17 14.2251 15.133 13.5977 15.133 11.0862Z"
        fill="#FF1D1D"
      />
      <path
        d="M4 4.10521C3.73481 4.10515 3.4805 3.99421 3.293 3.79679L2.293 2.74418C2.11085 2.54565 2.01005 2.27976 2.01233 2.00376C2.01461 1.72777 2.11978 1.46376 2.30518 1.2686C2.49059 1.07344 2.7414 0.962733 3.0036 0.960334C3.2658 0.957936 3.5184 1.06403 3.707 1.25578L4.707 2.30839C4.84681 2.4556 4.94202 2.64314 4.98059 2.8473C5.01915 3.05146 4.99935 3.26307 4.92368 3.45538C4.84801 3.6477 4.71987 3.81208 4.55546 3.92774C4.39105 4.04341 4.19775 4.10517 4 4.10521Z"
        fill="#FF1D1D"
      />
      <path
        d="M2 8.31567H1C0.734784 8.31567 0.48043 8.20477 0.292893 8.00736C0.105357 7.80996 0 7.54222 0 7.26305C0 6.98388 0.105357 6.71614 0.292893 6.51874C0.48043 6.32133 0.734784 6.21043 1 6.21043H2C2.26522 6.21043 2.51957 6.32133 2.70711 6.51874C2.89464 6.71614 3 6.98388 3 7.26305C3 7.54222 2.89464 7.80996 2.70711 8.00736C2.51957 8.20477 2.26522 8.31567 2 8.31567Z"
        fill="#FF1D1D"
      />
      <path
        d="M16 4.1052C15.8022 4.10516 15.609 4.0434 15.4445 3.92774C15.2801 3.81207 15.152 3.64769 15.0763 3.45538C15.0007 3.26306 14.9808 3.05145 15.0194 2.84729C15.058 2.64314 15.1532 2.4556 15.293 2.30839L16.293 1.25577C16.3852 1.15524 16.4956 1.07504 16.6176 1.01988C16.7396 0.964711 16.8708 0.935673 17.0036 0.934459C17.1364 0.933244 17.2681 0.959877 17.391 1.0128C17.5138 1.06573 17.6255 1.14389 17.7194 1.24272C17.8133 1.34156 17.8875 1.45908 17.9378 1.58845C17.9881 1.71781 18.0134 1.85642 18.0123 1.99618C18.0111 2.13595 17.9835 2.27407 17.9311 2.4025C17.8787 2.53092 17.8025 2.64707 17.707 2.74417L16.707 3.79679C16.5195 3.99421 16.2652 4.10514 16 4.1052Z"
        fill="#FF1D1D"
      />
      <path
        d="M19 8.31567H18C17.7348 8.31567 17.4804 8.20477 17.2929 8.00736C17.1054 7.80996 17 7.54222 17 7.26305C17 6.98388 17.1054 6.71614 17.2929 6.51874C17.4804 6.32133 17.7348 6.21043 18 6.21043H19C19.2652 6.21043 19.5196 6.32133 19.7071 6.51874C19.8946 6.71614 20 6.98388 20 7.26305C20 7.54222 19.8946 7.80996 19.7071 8.00736C19.5196 8.20477 19.2652 8.31567 19 8.31567Z"
        fill="#FF1D1D"
      />
      <path
        d="M6.823 17.7892C7.08828 18.445 7.53089 19.0043 8.09576 19.3973C8.66064 19.7904 9.32285 20 10 20C10.6772 20 11.3394 19.7904 11.9042 19.3973C12.4691 19.0043 12.9117 18.445 13.177 17.7892H6.823Z"
        fill="#FF1D1D"
      />
    </g>
    <defs>
      <clipPath id="clip0_6666_3221">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </SvgIcon>
)

const MainNavigation = ({ header, general }: IProps) => {
  const [isOpen, setIsOpen] = useState(false)

  const openMenu = () => {
    if (!isOpen) document.body.style.overflow = 'hidden'
    else document.body.style.overflow = ''
    setIsOpen(!isOpen)
  }
  return (
    <>
      <header className="w-full bg-black z-[300] flex justify-center items-center flex-col max-[1200px]:fixed max-[1200px]:h-[56px] leading-[20.8571px]">
        <div className="w-[1200px] h-[36px] max-[1200px]:hidden flex flex-row items-center justify-end max-[1200px]:w-full">
          <div className="flex flex-row relative items-center right-[22px]">
            <div className="flex justify-between h-[30px] w-auto">
              <div className="leading-[20px] flex">
                {header?.reportIndicident && (
                  <CMButton
                    buttonType="reportIndividualButton"
                    buttonText="REPORT AN INDIVIDUAL"
                    href="/report_an_individual"
                    link={true}
                    className="reportIncident"
                    target={false}
                  >
                    <div className={'mr-1'}>{reportIndividualSvg}</div>
                  </CMButton>
                )}
                {header?.reportIndicident && (
                  <CMButton
                    buttonType="reportIndividualButton"
                    buttonText="REPORT AN EVENT"
                    href="/report_an_event"
                    link={true}
                    className="reportIncident"
                    target={false}
                  >
                    <div className={'mr-1'}>{reportIncidentSvg}</div>
                  </CMButton>
                )}
              </div>
              {header?.socialMediaLink &&
                general?.socialMediaLinks?.map((item: SocialLinkItem) => (
                  <SocialMediaLink
                    socialLink={{ link: item.link, platform: item.platform, id: item.id }}
                    width={16}
                    height={16}
                    key={item.link}
                  />
                ))}
            </div>
          </div>
        </div>
        <div className="h-[0.5px] bg-[#E1E1E1] w-full"></div>
        <div className="w-full max-w-[1200px] flex h-[61px] items-center flex-grow z-[150] py-0 px-[20px] max-[1200px]:justify-center">
          <div
            className="max-[1200px]:absolute max-[1200px]:flex max-[1200px]:items-center max-[1200px]:left-[10px] max-[1200px]:z-[3] relative hidden w-[35px] h-[25px] cursor-pointer"
            onClick={openMenu}
          >
            {isOpen === false ? (
              <Image alt="list" width={35} height={35} src="/images/favicons/list.svg" />
            ) : (
              <Image alt="x" width={35} height={35} src="/images/favicons/x-close-button.svg" />
            )}
          </div>
          <div className="min-w-[163px] !max-h-[36px] relative z-[2] max-[1200px]:flex max-[1200px]:justify-center max-[1200px]:w-full max-[1200px]:relative max-[1200px]:right-0 max-[1200px]:bottom-0 max-[1200px]:z-[2]">
            <ImageLink
              href={`${general?.logo?.logourl}`}
              src="/images/favicons/Logo SVG-03.svg"
              width={163}
              height={36}
              alt="logo"
            />
          </div>
          <SideBar
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            {...{ header: header, general: general }}
          />
          <div className="max-[1200px]:hidden w-full max-w-[1200px]">
            <NavLinks viewPort={ViewPort.DESKTOP} {...{ header: header, general: general }} />
          </div>
        </div>
      </header>
    </>
  )
}
export default MainNavigation
